import { Button } from "@maker/design-system/ui/button";
import { Menu, MenuItem } from "@maker/design-system/ui/menu";
import {
	BookAIcon,
	ChevronLeftIcon,
	DownloadIcon,
	UsersIcon,
} from "lucide-react";
import { useEffect } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router";
import { useParamsOrThrow } from "../../../../hooks/use-params-or-throw";
import { useQueryTranscription } from "../../../../hooks/use-transcriptions";

const TranscriptionsTranscriptionPage = () => {
	const navigate = useNavigate();
	const { id } = useParamsOrThrow<"id">();
	const { data } = useQueryTranscription(id, { throwOnError: true });
	const menu = [
		{ href: "", content: <BookAIcon /> },
		{
			href: "participants",
			content: <UsersIcon />,
		},
		{
			href: "export",
			content: <DownloadIcon />,
		},
	];

	useEffect(() => {
		if (!data) {
			navigate("/");
		}
	}, [data, navigate]);

	if (!data) {
		return null;
	}

	return (
		<section className="flex h-full flex-1 flex-col">
			<div className="border-neutral-100 border-y px-6 py-4">
				<div className="grid grid-cols-12 items-center gap-4 rounded-lg">
					<div className="col-span-2 flex">
						<Button
							variant="white"
							icon="xs"
							render={<Link to="/" />}
							nativeButton={false}
						>
							<ChevronLeftIcon />
						</Button>
					</div>

					<h2 className="col-span-10 line-clamp-1 text-center font-semibold text-sm sm:col-span-8">
						{data.title}
					</h2>
				</div>
			</div>

			<div className="flex min-h-0 flex-1 flex-col">
				<Menu>
					{menu.map((item) => (
						<MenuItem
							render={
								<NavLink to={item.href} end>
									{item.content}
								</NavLink>
							}
							key={item.href}
							format="icon"
						>
							{item.content}
						</MenuItem>
					))}
				</Menu>

				<div className="min-h-0 flex-1">
					<Outlet />
				</div>
			</div>
		</section>
	);
};

export default TranscriptionsTranscriptionPage;
